import JsonViewer from 'vue-json-viewer';
import i18n from '../locales';
import routeDetailModalEscl from '../locales/es-CL/routeDetailModal.json';
import routeDetailModalEsmx from '../locales/es-MX/routeDetailModal.json';
import routeDetailModalEsco from '../locales/es-CO/routeDetailModal.json';
import routeDetailModalEnus from '../locales/en-US/routeDetailModal.json';

export default {
  props: ['urlImage', 'selectedActivity'],
  components: { JsonViewer },
  name: 'detailImage',
  methods: {
    t(key, value) {
      return i18n.t(key, value);
    },
    closeModal() {
      this.$bvModal.hide('activity-image-form-modal');
    },
  },
  mounted() {
    this.$root.$on('bv::modal::hide', () => {
      this.$destroy(); // cleanup in component
      this.$el.remove();
    });
    i18n.setLocaleMessage('es-CL', {
      ...i18n.messages['es-CL'],
      routeDetailModal: routeDetailModalEscl,
    });

    i18n.setLocaleMessage('es-MX', {
      ...i18n.messages['es-MX'],
      routeDetailModal: routeDetailModalEsmx,
    });

    i18n.setLocaleMessage('es-CO', {
      ...i18n.messages['es-CO'],
      routeDetailModal: routeDetailModalEsco,
    });

    i18n.setLocaleMessage('en-US', {
      ...i18n.messages['en-US'],
      routeDetailModal: routeDetailModalEnus,
    });
  },
};
